import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

export const Activities = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="activity-header">
      <h2>
          {t("navBar.home")} <span>/ {t("navBar.activities")}</span>
        </h2>     
         </div>

      <div className="activity">
        <h1>{t("activities.title")}</h1>
        <h2>{t("activities.subtitle")}</h2>
        <p>{t("activities.description")}</p>

        <h3>{t("activities.educationTitle")}</h3>
        <p>{t("activities.educationText")}</p>

        <h3>{t("activities.researchTitle")}</h3>
        <p>{t("activities.researchText")}</p>

        <h3>{t("activities.advocacyTitle")}</h3>
        <p>{t("activities.advocacyText")}</p>

        <h3>{t("activities.innovationTitle")}</h3>
        <p>{t("activities.innovationText")}</p>
      </div>
    </>
  );
};
